import React, { useState, useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { Drawer } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import loaderData from "../../assets/loader.json";
import BackArrow from "../../atoms/backArrow/backArrow";
import rightArrow from "../../assets/images/right_caret.svg";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import LoaderLight from "../../atoms/loaderLight/loaderLight";
import UserIcon from "../../assets/testRide/userProfileIcon.svg";
import searchIcon from "../../assets/testRide/search-white.svg";
import graySearchIcon from "../../assets/testRide/gray-search.svg";
import { setCookie, getCookie } from "../../utils/utils";
import { makeAPICall } from "../../services/apiService";

import "./styles.scss";

const OffilneFinanceSearch = () => {
  const history = useHistory();
  const [openModal, setModal] = useState(false);
  const [orderIdText, setOrderIdText] = useState("");
  const [idInputClass, setIdInputClass] = useState("");
  const [orderIdTxtValid, setOrderIdTxtValid] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [authData, setAuthData] = useState({});
  const [selectedOrderDetails, setSelectedOrderDetails] = useState({});
  const [redirectUrl, setRedirectUrl] = useState("");
  const [disabled, setDisabled] = useState(false);

  const openMenu = Boolean(anchorEl);

  useEffect(() => {
    getFinanceUrl();
  }, [])

  const getFinanceUrl = () => {
    let config = {
      method: 'get',
      url: `api/loan/getFinanceRedirectUrl`,
    };
    makeAPICall(config)
      .then((resp) => {
        if (resp?.data) {
          setRedirectUrl(resp?.data?.FINANCE_REDIRECT_URL);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const orderIdTextChange = (e) => {
    if (e.target.value) {
      if (e.target.value.length == 6) {
        setOrderIdTxtValid(true);
      } else {
        setIdInputClass("input-green");
        setShowErrorMsg(false);
        setOrderIdTxtValid(false);
      }
      setOrderIdText(e.target.value);
    } else {
      setOrderIdTxtValid(false);
      setOrderIdText("");
      setIdInputClass("");
      setOrdersList([]);
    }
  };

  const orderIdFocus = () => {
    setIdInputClass("input-green");
  };

  const orderIdBlur = () => {
    setIdInputClass("");
  };

  const searchById = () => {
    setLoader(true);

    let config = {
      method: "get",
      url: `api/loan/orderDetailsBySearch`,
      params: {
        orderId: orderIdText,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          if (resp.data.data.length !== 0) {
            setOrdersList(resp.data.data);
          } else {
            setShowErrorMsg(true);
            setOrdersList([]);
            setIdInputClass("input-error");
          }
        }

        setLoader(false);
      })
      .catch((err) => {
        setShowErrorMsg(true);
        setIdInputClass("input-error");
        setLoader(false);
      });
  };

  const redirectToInitiateLoan = (selectedOrder) => {
    setSelectedOrderDetails(selectedOrder);
    setDisabled(true);
    localStorage.setItem("loanOrderDetails", JSON.stringify(selectedOrder));

    let config = {
      method: "post",
      url: `api/loan/initiateFinance`,
      data: {
        order_id: selectedOrder.order_id,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        console.log("submitOfflinePayment", resp)
        if(resp && resp.data.status === "SUCCESSFUL"){
          const newJourneyId = resp.data.data.response['Journey-Id'];
          setAuthData(resp.data.data.response);
          submitFinanceForm(resp.data.data.response);
        }
        setDisabled(false);
        setLoader(false);
      })
      .catch((err) => {
        setDisabled(false);
        setLoader(false);
      });
    // history.push({
    //   pathname: "/initiate-loan",
    // });
  };


  const submitFinanceForm = ()=>{

    let formToSend = document.getElementById('form_ref_bank');
      
    if(formToSend){
      formToSend.submit();
    }
     
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onCloseMenu = () => {
    setAnchorEl(null);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setModal(true);
  };


  const completeLogout = () => {
    let logoutconfig = {
      method: "put",
      url: `/api/user/logout`,
      headers: {
        oem_auth_token: getCookie("oem_auth_token"),
      },
      data: {},
    };
    makeAPICall(logoutconfig)
      .then((data) => {
        console.log("Sucess ", data);
        history.push("/phoneNumber");
      })
      .catch((e) => {
        console.log("Fail ", e);
      });

    setAnchorEl(null);
  };

  let bcUserDetails = JSON.parse(localStorage.getItem('bcUserDetails') || "{}");
  return (
    <div className="loan-container">
      <div className="header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Link to="/booking-list">
            <BackArrow removeClass={true} />
          </Link>
          <div className="header-text">Offline financing</div>
        </div>

        <div>
          <img
            src={UserIcon}
            alt="userIcon"
            onClick={handleClick}
            style={{ "pointer-events": "all" }}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={onCloseMenu}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={closeMenu} className="menuUI">
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div className="inner-container">
        <div className="form-container">
          <div className="loan-inputfield">
            <FloatingInput
              id="orderId"
              name="orderId"
              type="text"
              labelName="Enter last 6 digits of order ID"
              inputValue={orderIdText}
              onChange={orderIdTextChange}
              className={`card-number ${idInputClass}`}
              placeholder="Enter last 6 digits of order ID"
              onFocus={orderIdFocus}
              onBlur={orderIdBlur}
              maxLength={6}
              labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
            />
            {showErrorMsg && (
              <div className="error-msg-container">
                <span className="error-msg-text">Invalid order ID</span>
              </div>
            )}
          </div>
          {loader ? (
            <button className={`search-disable-button`}>
              <div className="loader-container-np">
                <LoaderLight
                  loaderData={loaderData}
                  loaderStyle="loader-light-np"
                />
              </div>{" "}
            </button>
          ) : (
            <button
              className={
                orderIdTxtValid ? "search-button" : "search-disable-button"
              }
              type="submit"
              onClick={() => searchById()}
            >
              <img src={searchIcon} alt="searchIcon" />
            </button>
          )}
        </div>
        {ordersList.length == 0 ? (
          <div className="no-orders">
            <div
              style={{
                width: 180,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {/* <img
                src={graySearchIcon}
                alt="searchIcon"
                style={{ height: 60, width: 60 }}
              /> */}
              {/* <p>Enter last 6 digits of order ID to search</p> */}
              <p style={{ color: "rgb(108 104 104 / 86%)", textAlign: "center", width: "210px" }}>Special zero cost EMI available for IDFC Bank Loans</p>
            </div>
          </div>
        ) : (
          <div>
            {ordersList.map((order) => (
              <div
                className="orderlist-container"
                onClick={() => !disabled && redirectToInitiateLoan(order)}
              >
                <div>
                  <div className="order-number">{order.order_id}</div>
                  <div className="user-name">{order.name}</div>
                </div>
                <img
                  src={rightArrow}
                  alt="rightArrow"
                  style={{ height: 30, width: 30 }}
                />
              </div>
            ))}
          </div>
        )}
        <Drawer
          anchor={"bottom"}
          open={openModal}
          onClose={() => setModal(false)}
          PaperProps={{
            style: {
              borderRadius: 0,
            },
          }}
        >
          <div className="bc-modal-container">
            <div className="heading-container">Are you sure you want to Logout?</div>
            <div className="btn-container">
              <button onClick={() => setModal(false)} className="cancel-btn">
                Back
              </button>
              <button onClick={() => completeLogout()} className="confirm-btn">
                Yes
              </button>
            </div>
          </div>
        </Drawer>
      </div>
       <form id="form_ref_bank" action={redirectUrl} method="post">
          <input
            name="Journey-Id"
            type="hidden"
            value={authData?.['Journey-Id']}
          />
          <input
            name="app_version"
            type="hidden"
            value={getCookie('app_version')}
          />
          <input name="utm_source" type="hidden" value={getCookie('source')} />
          <input name="os_name" type="hidden" value={getCookie('os_name')} />
          <input
            name="os_version"
            type="hidden"
            value={getCookie('os_version')}
          />
          <input
            name="Authorization"
            type="hidden"
            value={authData?.['Authorization']}
          />
          <input name="productPartnerId" type="hidden" value="ola_electric" />
          <input name="productId" type="hidden" value="ev_tw" />
          <input name="agentEmailId" type="hidden" value={bcUserDetails?.email} />
          <input name="orderId" type="hidden" value={selectedOrderDetails?.order_id} />
          <input name="agentId" type="hidden" value={getCookie('utm_uuid')} />
        </form>

    </div>
  );
};

export default OffilneFinanceSearch;
